module.exports = OK_REACT_core;